import { render, staticRenderFns } from "./HjqkmxForm.vue?vue&type=template&id=54ca9c00"
import script from "./HjqkmxForm.vue?vue&type=script&lang=js"
export * from "./HjqkmxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports